'use strict';

export default {
  reports: {
    existingReports: 'Rapports existants',
    addReport: 'Ajouter un rapport',
    cancel: 'Annuler',
    delete: 'Supprimer',
    deleteReports: 'Supprimer ce rapport ?',
    deleteModal: 'Suppression de rapport',
    generate: 'Générer',
    save: 'Sauvegarder',
    checkAll: 'Cocher Tous',
    uncheckAll: 'Décocher Tous',
    noFields: 'Aucun Champs',
    formId: 'Id du formulaire: ',
    saveSuccess: 'Rapport sauvegardé avec succès',
    createSuccess: 'Rapport créé avec succès',
    updateReportError: 'Erreur lors de la sauvegarde du rapport',
    createReportError: 'Erreur lors de la création du rapport',
    reportName: 'Nom du rapport',
    emptyReportName: 'Veuillez donner un nom valide au rapport',
    noReports: "Il n'y pas de rapports pour cette organisation",
    noSavedReports: "Il n'y pas encore de rapports sauvegardés",
    returnToReports: 'Revenir aux rapports',
    toForms: 'Aller à la page des formulaires',
    viewReports: 'Voir les rapports',
    editReport: 'Modifier le rapport',
    downloadReport: 'Télécharger le rapport',
    deleteReport: 'Supprimer le rapport',
    paymentsSectionName: 'Paiements',
    adminSectionName: 'Administration',
    adminStepName: 'Général',
    formTotalPaid: 'Total payé',
    paymentMethod: 'Méthode de paiement',
    paymentStatus: 'Statut du paiement',
    submissionId: 'Identifiant de soumission',
    discount: 'Rabais',
    paymentMode: 'Mode de paiement',
    discountCode: 'Code rabais',
    submissionDate: 'Date de soumission',
    receiptEmail: 'Courriel de reçu',
  },
};
